import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=dd83796e&scoped=true&lang=pug"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"
import style0 from "./Button.vue?vue&type=style&index=0&id=dd83796e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd83796e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LsButtonSpinner: require('/workspace/portal/hosting/components/_base/Button/ButtonSpinner/ButtonSpinner.vue').default})
